/**
 * Grid Slider — view.js
 *
 * Initialises Swiper and count-up animation for each .nl-grid-slider instance.
 * Count always starts from 0. Triggers on scroll into view and on slide change.
 */

( function ( factory ) {
    if ( window.jQuery ) {
        factory( window.jQuery );
    } else {
        console.warn( 'Grid Slider view.js: jQuery not found. Count-up animation disabled.' );
    }
} )( function ( $ ) {

    // ── Count-up helpers ──────────────────────────────────────────

    function animateCount( $el, end, duration ) {
        const endNum = parseFloat( end );
        if ( ! isFinite( endNum ) ) return;
        const decimals = ( String( end ).split( '.' )[ 1 ] || '' ).length;
        const startTime = performance.now();

        function tick( now ) {
            const t = Math.min( 1, ( now - startTime ) / duration );
            const eased = 1 - Math.pow( 1 - t, 3 ); // easeOutCubic
            const value = endNum * eased;
            $el.text( value.toFixed( decimals ) );
            if ( t < 1 ) {
                requestAnimationFrame( tick );
            } else {
                $el.text( endNum.toFixed( decimals ) );
            }
        }

        requestAnimationFrame( tick );
    }

    function runCountUp( $el ) {
        if ( $el.data( 'animated' ) ) return;
        const end = $el.attr( 'data-end' );
        if ( ! end ) return;
        $el.data( 'animated', true );
        setTimeout( function () {
            animateCount( $el, end, 1200 );
        }, 150 );
    }

    // ── Swiper init ───────────────────────────────────────────────

    $( function () {
        document.querySelectorAll( '.nl-grid-slider' ).forEach( function ( el ) {
            const swiper = new Swiper( el, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                speed: 600,
                keyboard: { enabled: true },
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                parallax: true,
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: true,
                    stopOnLastSlide: false,
                },
                pagination: {
                    el: el.querySelector( '.nl-grid-slider-pagination' ),
                    clickable: true,
                    bulletClass: 'nl-slider-bullet',
                    bulletActiveClass: 'nl-slider-bullet--active',
                    renderBullet: function ( index, className ) {
                        return '<span class="' + className + '"></span>';
                    },
                },
                on: {
                    // Fire count-up when a slide becomes active
                    slideChangeTransitionStart: function () {
                        const $active = $( this.slides[ this.activeIndex ] ).find( '.js-countup' );
                        $active.each( function () {
                            $( this ).text( '0' );
                            $( this ).removeData( 'animated' );
                        } );
                    },
                    slideChangeTransitionEnd: function () {
                        const $active = $( this.slides[ this.activeIndex ] ).find( '.js-countup' );
                        $active.each( function () {
                            runCountUp( $( this ) );
                        } );
                    },
                },
            } );

            // Fire count-up for the first visible slide on load
            // using IntersectionObserver so it triggers on scroll into view
            if ( 'IntersectionObserver' in window ) {
                const observer = new IntersectionObserver( function ( entries ) {
                    entries.forEach( function ( entry ) {
                        if ( entry.isIntersecting ) {
                            observer.unobserve( entry.target );
                            const $targets = $( entry.target ).find( '.swiper-slide-active .js-countup' );
                            $targets.each( function () {
                                runCountUp( $( this ) );
                            } );
                        }
                    } );
                }, { threshold: 0.2 } );
                observer.observe( el );
            } else {
                // Fallback: run immediately on DOM ready
                $( el ).find( '.swiper-slide-active .js-countup' ).each( function () {
                    runCountUp( $( this ) );
                } );
            }
        } );
    } );

} );